function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "ICONS/TOOLS/ico-30-duplicate");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  stroke: "#000000",
  transform: "translate(15.000000, 15.000000) scale(1, -1) translate(-15.000000, -15.000000) translate(2.500000, 4.500000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16,17.8 C16,19.5673112 14.5673112,21 12.8,21 L4,21 C1.790861,21 2.705415e-16,19.209139 0,17 L0,9 C-2.705415e-16,6.790861 1.790861,5 4,5 L6.93333333,5 L6.93333333,5",
  id: "Path"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 9,
  y: 0,
  width: 16,
  height: 16,
  rx: 4
}), /*#__PURE__*/React.createElement("line", {
  x1: 17,
  y1: 11,
  x2: 17,
  y2: 5,
  id: "Line-Copy"
}), /*#__PURE__*/React.createElement("line", {
  x1: 20,
  y1: 8,
  x2: 14,
  y2: 8,
  id: "Line"
})));

const SvgIco30Duplicate = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30px",
  height: "30px",
  viewBox: "0 0 30 30",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIco30Duplicate, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ico-30-duplicate.16c28e56.svg";
export { ForwardRef as ReactComponent };